import { customHtml } from '@yola/ws-sdk';
import getProhibitedHtmlTagAnnotations from './get-prohibited-html-tag-annotations';

const { validateTemplate } = customHtml.validations;

function getTemplateValidationAnnotation(validationResult) {
  if (validationResult.valid) {
    return null;
  }

  const { line, column, error } = validationResult;

  return {
    row: Math.max(0, (line ?? 1) - 1),
    column: Math.max(0, column ?? 0),
    type: 'error',
    text: error,
  };
}

function getCustomHtmlCodeEditorAnnotations({ value = '', session }) {
  const validationResult = validateTemplate(value);
  const templateAnnotation = getTemplateValidationAnnotation(validationResult);
  const prohibitedHtmlTagAnnotations = getProhibitedHtmlTagAnnotations(value, session);

  if (!templateAnnotation) {
    return prohibitedHtmlTagAnnotations;
  }

  return [templateAnnotation, ...prohibitedHtmlTagAnnotations];
}

export default getCustomHtmlCodeEditorAnnotations;
